import React from "react";
import { ArticleAppendixVersion } from "../../../../amorg-common";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { FormField } from "../../../../designSystem/formField/FormField";
import { Modal } from "../../../../designSystem/Modal";
import { Table, TableRowWithOnClick } from "../../../../designSystem/Table";
import { PageSection } from "../../../../designSystem/PageSection";

type AppendixPanelProps = {
    appendices: ArticleAppendixVersion[]
};
export function AppendixPanel (props: AppendixPanelProps): JSX.Element
{
    const [showAppendixId, setShowAppendixId] = React.useState('');

    return (
        <div>
            <PageSection
                header={{
                    title: 'Ændringsbekendtgørelser',
                    defaultCollapsed:false,
                    avatar:{ text: props.appendices.length.toString() }
                }}
                headerStyleVariant="card"
                contentStyleVariant="card"
                contentPadding="0px">

                <Table noOuterBorder>
                    <thead>
                        <tr>
                            <th>Titel</th>
                            <th>Type</th>
                            <th>Emne</th>
                            <th>Lovnummer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.appendices.length === 0 &&
                            <tr>
                                <td colSpan={4}>Der er ingen ændringsbekendtgørelser</td>
                            </tr>}
                        {props.appendices.sort((a, b) => {
                            return (b.date?.getTime() ?? -Infinity) - (a.date?.getTime() ?? -Infinity)
                        }).map((appendix) => 
                            <TableRowWithOnClick key={appendix.id} onClick={() => setShowAppendixId(appendix.id)}>
                                <td>{appendix.title}</td>
                                <td>{appendix.type.name}</td>
                                <td>{appendix.topic.name}</td>
                                <td>{appendix.reference}</td>
                            </TableRowWithOnClick>
                        )}
                    </tbody>
                </Table>
            </PageSection>

            <ViewAppendixModal appendix={props.appendices.find(a => a.id === showAppendixId)} onClose={() => setShowAppendixId('')} />

        </div>
    );
}

type ViewAppendixModalProps = {
    appendix?: ArticleAppendixVersion,
    onClose(): void;
}
export function ViewAppendixModal (props: ViewAppendixModalProps): JSX.Element
{

    return (
        <>
            {props.appendix &&
                <Modal title='Ændringsbekendtgørelse' showModal={true} onCancel={props.onClose}
                    content={
                        <Flex flexDirection='column' gap={16}>

                            <FormField
                                label='Titel'
                                inputComponent={<span>{props.appendix.title}</span>}
                            />
                            <FormField
                                label='Lovnummer'
                                inputComponent={<span>{props.appendix.reference}</span>}
                            />

                            <FormField
                                label='Webaddresse'
                                inputComponent={
                                    <>
                                        {props.appendix.url &&
                                            <a href={props.appendix.url.toLowerCase().startsWith('www')
                                                    ? `http://${props.appendix.url}`
                                                    : props.appendix.url
                                            } target='_blank' rel='noreferrer'>Gå til webaddressen</a>
                                        }
                                        {!props.appendix.url &&
                                            <span>ikke angivet</span>
                                        }
                                    </>
                                }
                            />

                            <FormField
                                label='Type lovkrav'
                                inputComponent={<span>{props.appendix.type.name}</span>}
                            />

                            <FormField
                                label='Liste/emne'
                                inputComponent={<span>{props.appendix.topic.name}</span>}
                            />

                            <FormField
                                label='Dato'
                                inputComponent={<span>{props.appendix.date?.toLocaleDateString()}</span>}
                            />

                            <FormField
                                label='Beskrivelse'
                                inputComponent={<span>{props.appendix.description}</span>}
                            />
                        </Flex>
                    } />
                }
        </>
    );
}